import React, { useState, useEffect, useRef } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { FloatingSubmit } from '../UIUtilsFiles/FloatingSubmit'

function RichTextEditor(props) {
  const {
    listData,
    onValueChange,
    defaultValue,
    initial,
    completed,
    isActive,
    isEmbeded,
    onPriorityChange,
    onDisplayDoneClick,
    currentPriority
  } = props
  const { ControlID, Value, Editable, Priority } = listData

  const [richTextValue, setRichTextValue] = useState('')
  const [displayDone, setDisplayDone] = useState(false)

  let modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [
        { list: 'ordered' },
        { list: 'bullet' },
        { indent: '-1' },
        { indent: '+1' }
      ],
      ['link', 'image']
      // ["clean"],
    ]
  }
  let modulesEmpty = {
    toolbar: false
  }

  let formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image'
  ]

  useEffect(() => {
    if (currentPriority === Priority) {
      setDisplayDone(true)
    } else {
      setDisplayDone(false)
    }
  }, [currentPriority])

  useEffect(() => {
    if (initial) {
      let contentBlock = ''
      if (defaultValue) {
        contentBlock = defaultValue
      } else {
        contentBlock = Value
      }

      setRichTextValue(contentBlock)
    }
  }, [defaultValue, initial])

  function onEditorValueChange(editorValue) {
    setRichTextValue(editorValue)
    onValueChange({ Answer: editorValue, Value: 0 }, ControlID, true)
  }

  //Hide tick icon when activity is completed
  useEffect(() => {
    if (completed === 1 || !isActive) {
      setDisplayDone(false)
    }
  }, [completed, isActive])

  useEffect(() => {
    if (onDisplayDoneClick) {
      if (displayDone) {
        onDisplayDoneClick({ id: ControlID, displayDone: displayDone })
      } else {
        onDisplayDoneClick({ id: undefined, displayDone: displayDone })
      }
    }
  }, [displayDone])

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        zIndex: 6,
        overflow: 'scroll'
      }}
    >
      <ReactQuill
        id={ControlID}
        theme='snow'
        modules={Editable ? modules : modulesEmpty}
        formats={formats}
        readOnly={
          Editable ? (completed === 0 && isActive ? false : true) : true
        }
        onChange={(value) => {
          onEditorValueChange(value)
        }}
        value={richTextValue}
        placeholder='Text goes here'
      />
      {isEmbeded && displayDone && Editable && (
        <FloatingSubmit
          submitClicked={() => {
            setDisplayDone(false)
            onPriorityChange(Priority)
          }}
        />
      )}
    </div>
  )
}

export default RichTextEditor
